import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewChild,
  TemplateRef
} from "@angular/core";
import { UtenteVO } from "@app/shared/vo/utenteVO";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { ProfiliService } from "@app/shared/services/profili.service";
import { SettoreVO } from "@app/shared/vo/settoreVO";

@Component({
  selector: "app-modale-estensori",
  templateUrl: "./modale-estensori.component.html"
})
export class ModaleEstensoriComponent implements OnInit {
  @Output()
  changeEstensore: EventEmitter<UtenteVO> = new EventEmitter<UtenteVO>();
  messages = {
    emptyMessage: "Nessun risultato",
    totalMessage: "in totale"
  };

  assegnati: UtenteVO[] = new Array<UtenteVO>();
  nonAssegnati: UtenteVO[] = new Array<UtenteVO>();
  public modalRef: BsModalRef;
  estensoriList: UtenteVO[] = [];
  estensoriListCopia: UtenteVO[];
  @Output()
  abilitaButtonPadreOut: EventEmitter<boolean> = new EventEmitter();
  private config = {
    class: "modal-dialog modal-info modal-xlg",
    animated: true
  };
  @ViewChild("templateModaleEstensori", { static: false })
  public estensoriModal: TemplateRef<any>;
  // firmatariList: UtenteVO[] = new Array<UtenteVO>();
  estensoreSelezionato: UtenteVO = new UtenteVO();
  constructor( 
    private profiliService: ProfiliService,
    private modalService: BsModalService
  ) {}

  ngOnInit() {}

  abilitaButtonPadre() {
    this.abilitaButtonPadreOut.emit(true);
  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.estensoriListCopia.filter(function(d) {
      return d.username.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.estensoriList = temp;
    // Whenever the filter changes, always go back to the first page
    //   this.table.offset = 0;
  }

  public openModal(settore: SettoreVO, isResponsabile?: boolean) {
    this.estensoriList = new Array<UtenteVO>();
    this.estensoreSelezionato = new UtenteVO();
    if (isResponsabile) {
      this.getResponsabili(settore);
    } else {
      // this.getEstensori(settore);
      this.getEstensoriAndConsultatori(settore);
    }
  }

  private async getEstensoriAndConsultatori(settore: SettoreVO) {
    const estensoriPrimaParte: UtenteVO[] = [];
    const utentiEstensori: UtenteVO[] = await this.profiliService
      .getUtentiEstensori(settore.codice)
      .toPromise();
    const utentiConsultatori: UtenteVO[] = await this.profiliService
      .getUtentiConsultatori(settore.codice)
      .toPromise();

    for (let index = 0; index < utentiEstensori.length; index++) {
      estensoriPrimaParte.push(utentiEstensori[index]);
    }

    for (let index = 0; index < utentiConsultatori.length; index++) {
      const checkRoleExistence = roleParam =>
        estensoriPrimaParte.some(({ id }) => id === roleParam);
      if (!checkRoleExistence(utentiConsultatori[index].id)) {
        estensoriPrimaParte.push(utentiConsultatori[index]);
      }
    }

    this.estensoriList = estensoriPrimaParte;
    this.estensoriListCopia = this.estensoriList;
    /*       if (this.visibilitaPartenza) {
        this.filtraGiaAssegnati();
        this.riordinaLista();
        this.estensoriListCopia = this.estensoriList;
      } */
    this.modalRef = this.modalService.show(this.estensoriModal, this.config);
  }

  private getResponsabili(settore: SettoreVO) {
    this.profiliService.getUtentiResponsabili(settore.codice).subscribe(
      res => {
        console.log("[responsabili-settore][", settore.codice, "] ", res);
        this.estensoriList = res;
        this.estensoriListCopia = this.estensoriList;
        /*     if (this.visibilitaPartenza) {
        this.filtraGiaAssegnati();
        this.riordinaLista();
        this.estensoriListCopia = this.estensoriList;
      } */
        this.modalRef = this.modalService.show(
          this.estensoriModal,
          this.config
        );
      },
      err => {
        console.log(
          "recupero Estensori Component ModaleEstensoriComponent err",
          err
        );
      }
    );
  }

  private getEstensori(settore: SettoreVO) {
    this.profiliService.getUtentiEstensori(settore.codice).subscribe(
      res => {
        console.log("[estensori-settore][", settore.codice, "] ", res);
        this.estensoriList = res;
        this.estensoriListCopia = this.estensoriList;
        /*     if (this.visibilitaPartenza) {
        this.filtraGiaAssegnati();
        this.riordinaLista();
        this.estensoriListCopia = this.estensoriList;
      } */
        this.modalRef = this.modalService.show(
          this.estensoriModal,
          this.config
        );
      },
      err => {
        console.log(
          "recupero Estensori Component ModaleEstensoriComponent err",
          err
        );
      }
    );
  }

  private riordinaLista() {
    this.estensoriList = new Array<UtenteVO>();
    this.assegnati.forEach(element => {
      this.estensoriList.push(element);
    });
    this.nonAssegnati.forEach(element => {
      this.estensoriList.push(element);
    });
  }

  seleziona() {
    console.log("seleziona: ", JSON.stringify(this.estensoreSelezionato));

    this.changeEstensore.emit(this.estensoreSelezionato);
    this.modalRef.hide();
  }

  private selezioneTrue(e, estensore) {
  
    if (e.target.checked) {
      this.estensoreSelezionato = estensore;
      this.estensoriList.forEach(estensoreLista => {
        if (estensoreLista.id !== estensore.id) {
          estensoreLista.check = false;
        }
      });
    } 
    console.log("selezioneTrue end", this.estensoreSelezionato);
  }
}
